import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { appPaginationStore } from "@/store/modules/appPagination";
import { AppStateStore } from "@/store/modules/appState";
import { PaginationMix } from '@/UI/mixins/PaginationMix'
import { getStudioId } from "@/UI/lib/state";

@Component
export class ProxyGetData extends mixins(
    PaginationMix
) {
    @Prop() readonly source!: string

    pagination: any = appPaginationStore.PageParams
    table_load: boolean = true
    disabled_sort: boolean = true
    formReady: boolean = false
    pager: any = null
    filter_load: boolean = false
    proxyFilter: any = {}
    filterTimer: any = null
    routeTimer: any = null

    proxySorting: any = {
        sort: '',
        by: ''
    }

    async fetchModules(source_params: any): Promise<void> {
        for (const i of source_params) {

            await this.$store.dispatch(i.s + "/fetchAll", i.p)
        }
    }

    async filterData(filter?: Record<string, any>): Promise<void> {
        this.proxyFilter = { ...this.proxyFilter, ...filter };
        const objects_value: any = Object.assign(this.proxyFilter);
        Object.keys(objects_value).forEach((key) => {
            if (objects_value[key] === "0" || objects_value[key] === "") {
                delete objects_value[key];
            }
        });
        this.proxyFilter = objects_value;
        /* 
            *************
            здесь proxyFilter нормально записывается
        */
    }

    @Watch("$store.state.appState.sendApplyFilters", { immediate: false })
    async onFilterApplySend(): Promise<void> {
        /* 
            *************
            здесь если AppStateStore.setApplyFilters(false) мы переносим ниже или 
            в методы ниже - идет большее количество вызовов именно в 
            компонентах SalonsFinance и SalonClients и они могут меняться местами
            и менять данные таблицы
        */
        AppStateStore.setApplyFilters(false);
        await this.onApplyFilters();
    }

    @Watch("$store.state.salon_id", { immediate: false })
    async onStudioChange(): Promise<void> {
        this.proxyFilter = {
            salon_id: getStudioId(this)
        };
        await this.onApplyFilters();
    }

    async onApplyFilters(): Promise<void> {
        // Отслеживание кнопки "применить фильтр"
        // Отслеживание смены студии
        clearTimeout(this.filterTimer);
        this.filterTimer = setTimeout(async () => {
            if (!this.proxyFilter.salon_id) {
                this.proxyFilter = { ...this.proxyFilter, ...{ salon_id: getStudioId(this) } };
            }

            AppStateStore.setApplyFilters(false);
            if (this.pager) {
                this.pager.current = 1;
            }
            await this.getData();
        }, 500);
    }


    async handlePagination(pager: any): Promise<void> {
        // Пагинация
        this.pager = pager
        this.$router.currentRoute.params.page = pager.current; // добавил т.к. на странице ServiceIndex не менялось
        await this.getData()
    }


    async sortedData(by: any, column?: any): Promise<void> {
        // Сортировка
        try {
            if (by === 'clear') {
                this.proxySorting = {}
                this.disabled_sort = true
            } else {
                this.proxySorting = {
                    sort: column.dataIndex,
                    by: by
                }
                this.disabled_sort = false
            }
            await this.getData()
        } catch (e) {
            console.error(e.message);
        }
    }


    async getData(): Promise<void> {
        /* 
            **********************
            proxyFilter в SalonsFinance и SalonClents не меняется в этом методе. 
            При этом в filterData меняется proxyFilter.
        */

        // Получение данных
        try {
            this.table_load = true
            const route = this.$router.currentRoute;
            let source: any = ''

            const RouterParams = this.$router.currentRoute.params
            if (RouterParams.page_size) {
                appPaginationStore.PageParams.pageSize = Number(RouterParams.page_size)
            }
            if (RouterParams["page"]) {
                appPaginationStore.setCurrent(Number(RouterParams["page"]))
            }

            if (this.$router.currentRoute["meta"]) {
                source = this.$router.currentRoute["meta"]["props"]
            }

            if (!this.pager) {
                this.pager = this.pagination
            }
            /* 
                *************
                здесь proxyFilter с дефолтным значением, хотя ранее в filterData
                мы записывали параметры туда
            */
            const param: Record<string, any> = {
                skip: this.calcSkip(this.pager),
                limit: this.pager.pageSize,
                filter: this.proxyFilter,
                sort: this.proxySorting.sort,
                by: this.proxySorting.by
            }

            await this.$store.dispatch(source["source"]["name"] + "/fetchAll", param);
            if (this.$router.currentRoute !== route) return;
            this.pagination.total = this.$store.state[source.source["root"]][source.source["items"]]["total"]
            this.pager.total = this.$store.state[source.source["root"]][source.source["items"]]["total"]

            if (this.pager) {
                appPaginationStore.PageParams.pageSize = this.pager.pageSize
                appPaginationStore.setCurrent(this.pager["current"])
                this.pagination.total = this.pager.total // Добавил для пагинации страницы Студии/Студия/Сотрудники
                this.AppPageParams.total = this.pager.total // Добавил при баге на странице Студии (баг после пагинации при использовании фильтров и последующего сброса - общее количество оставалось прежним). Задача в битриксе - 10141
            }
            const params: Record<string, any> = {
                Studio: getStudioId(this),
                page: this.pager.current,
                page_size: this.pager.pageSize,
                total: this.pager.total,
                filter: JSON.stringify(this.proxyFilter),
                sorted: JSON.stringify(this.proxySorting)
            };
            const currentHistoryParams = route.params;

            let needToChangeRoute = false;
            Object.keys(params).map((param) => {
                if (!currentHistoryParams.hasOwnProperty(param) || currentHistoryParams[param] != params[param]) {
                    needToChangeRoute = true;
                    return false;
                }
            });

            if (needToChangeRoute) {

                clearTimeout(this.routeTimer);
                this.routeTimer = setTimeout(async () => {
                    if (this.$router.currentRoute !== route) return;
                    console.log("change route: ", source.source["routePage"], "params: ", params)
                    await Vue.router.push({
                        name: source.source["routePage"],
                        params: params
                    })
                }, 500)

                this.$forceUpdate();
            }
        } catch (e) {
            console.error(e.message);
            console.error(e.stack);
        } finally {
            this.table_load = false
        }
    }

    beforeDestroy(): void {
        clearTimeout(this.filterTimer);
        clearTimeout(this.routeTimer);
    }

    deactivated(): void {
        clearTimeout(this.filterTimer);
        clearTimeout(this.routeTimer);
    }

    async fetchModule(source_params: Record<string, any>[]): Promise<void> {
        for (const i of source_params) {
            await this.$store.dispatch(i.s + "/fetchAll", i.p)
        }
    }
}
